import React from "react";
import { GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { ensureAudioFileRecordDetails, FileRecordDetails } from "../FileRecordDetails";

interface AudioFileRecordTechnicalViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const AudioFileRecordTechnicalView = ({ fileRecordDetails }: AudioFileRecordTechnicalViewProps): JSX.Element => {
    ensureAudioFileRecordDetails(fileRecordDetails);

    return (
        <GridRow>
            <GridColumn sm={3}>
                <LabeledText
                    label="Duration"
                    testId="file-record-technical-duration"
                    value={fileRecordDetails.technical?.duration}
                />
                <LabeledText
                    label="Channels"
                    testId="file-record-technical-channels"
                    value={fileRecordDetails.technical?.channelsCount}
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Bitrate"
                    testId="file-record-technical-audioBitRate"
                    value={fileRecordDetails.technical?.audioBitRate}
                />
                <LabeledText
                    label="Sample rate"
                    testId="file-record-technical-sampleRate"
                    value={fileRecordDetails.technical?.sampleRate}
                />
            </GridColumn>
            <GridColumn sm={3}>
                <LabeledText
                    label="Audio format"
                    testId="file-record-technical-audioFormat"
                    value={fileRecordDetails.technical?.audioFormat}
                />
            </GridColumn>
        </GridRow>
    );
};
